module.exports = __webpack_public_path__ + "f78b0e2263a0a7a4c8860c08e445efa8.MP3";